export const getQuantityDisplay = (
  quantity?: fhir4.Quantity,
): string | undefined => {
  if (!quantity) {
    return undefined;
  }

  const { value = '', unit = '' } = quantity;

  return `${value} ${unit}`;
};
